import { render, staticRenderFns } from "./MdCheckbox.html?vue&type=template&id=5f5a4e49&external"
import script from "./MdCheckbox.ts?vue&type=script&lang=ts&external"
export * from "./MdCheckbox.ts?vue&type=script&lang=ts&external"
import style0 from "./MdCheckbox.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports